import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PaymentSuccess() {
  const location = useLocation();
  localStorage.setItem("payment_success", "yes");
  localStorage.removeItem("payment_in_progress");
  useEffect(() => {
    const success = localStorage.getItem("payment_success");

    if (success !== "yes") {
      alert("Invalid access");
      window.location.href = "/login";
      return;
    }

    const params = new URLSearchParams(location.search);
    const paymentId = params.get("payment_id");

    if (paymentId) {
      alert("Payment Successful ✅");

      console.log("Payment ID:", paymentId);

      // 👉 Ahiya tokens add logic
      // Example:
      // call API / update localStorage / refresh limit
    }
  }, []);

  return <h1>Payment Successful ✅</h1>;
}
